import { connect } from "react-redux";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import PriceDetails from "app/pages/Booking/Quotation/PriceDetails/PriceDetails";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	getQuoteTotalWithDelta,
	getTotalExcludedTaxes,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { getEcheancier } from "app/pages/Booking/Payment/paymentSelector";
import { checkIsCreditUsageIsEnabled } from "app/reducers/partnerSelector";
import { getHideDiscountHBX } from "app/reducers/brandSelector";

const mapStateToProps = (state, ownProps) => {
	const booking = state.booking;
	const offerType = booking.offer.type;
	const currentPathname = ownProps.location.pathname;

	const isRestoreBookingSessionPage = matchPath(
		{
			path: "/booking/restoreSession",
		},
		currentPathname
	);

	const isPagePayment = currentPathname.includes("/booking/payment");
	const isPageQuote = currentPathname.includes("/booking/quote");
	const isSDP = currentPathname.includes("/sdp/");
	const mensualite = getEcheancier(state);

	const included =
		(isPagePayment || isPageQuote) && isSDP
			? state.ficheProduit.included
			: state.ficheProduit.included && state.ficheProduit.included[offerType];

	const notIncluded =
		(isPagePayment || isPageQuote) && isSDP
			? state.ficheProduit.notIncluded
			: state.ficheProduit.notIncluded && state.ficheProduit.notIncluded[offerType];

	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const prebookTotal = calculatePreBookTotal(state) - creditsApplied;
	const total =
		isPagePayment || isRestoreBookingSessionPage ? getQuoteTotalWithDelta(state) : prebookTotal;

	const totalExcludedTaxes = getTotalExcludedTaxes(state);

	return {
		brand: state.brand.code,
		shop: state.shop,
		total: total + totalExcludedTaxes,
		board: booking.board,
		coutCredit: mensualite.coutCredit,
		hasChildren: booking.children > 0,
		included,
		notIncluded,
		isPagePayment: isPagePayment || isRestoreBookingSessionPage,
		paymentType: booking.paymentType,
		paymentMode: booking.paymentMode,
		usableCouponsStatus: state.usableCoupons.status,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		hideDiscountHBX: getHideDiscountHBX(state),
	};
};

export const QuotationPriceDetailContainer = withRouter(connect(mapStateToProps)(PriceDetails));
